/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationMismatchRequestItem } from './SimulationMismatchRequestItem';
import {
    SimulationMismatchRequestItemFromJSON,
    SimulationMismatchRequestItemFromJSONTyped,
    SimulationMismatchRequestItemToJSON,
    SimulationMismatchRequestItemToJSONTyped,
} from './SimulationMismatchRequestItem';
import type { SimulationKeyFigureRequestItem } from './SimulationKeyFigureRequestItem';
import {
    SimulationKeyFigureRequestItemFromJSON,
    SimulationKeyFigureRequestItemFromJSONTyped,
    SimulationKeyFigureRequestItemToJSON,
    SimulationKeyFigureRequestItemToJSONTyped,
} from './SimulationKeyFigureRequestItem';

/**
 * 
 * @export
 * @interface RecordSimulationMismatchesRequestBody
 */
export interface RecordSimulationMismatchesRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RecordSimulationMismatchesRequestBody
     */
    prefix?: string | null;
    /**
     * 
     * @type {Array<SimulationMismatchRequestItem>}
     * @memberof RecordSimulationMismatchesRequestBody
     */
    mismatches: Array<SimulationMismatchRequestItem>;
    /**
     * 
     * @type {Array<SimulationKeyFigureRequestItem>}
     * @memberof RecordSimulationMismatchesRequestBody
     */
    keyFigures?: Array<SimulationKeyFigureRequestItem> | null;
}

/**
 * Check if a given object implements the RecordSimulationMismatchesRequestBody interface.
 */
export function instanceOfRecordSimulationMismatchesRequestBody(value: object): value is RecordSimulationMismatchesRequestBody {
    if (!('mismatches' in value) || value['mismatches'] === undefined) return false;
    return true;
}

export function RecordSimulationMismatchesRequestBodyFromJSON(json: any): RecordSimulationMismatchesRequestBody {
    return RecordSimulationMismatchesRequestBodyFromJSONTyped(json, false);
}

export function RecordSimulationMismatchesRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordSimulationMismatchesRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'mismatches': ((json['mismatches'] as Array<any>).map(SimulationMismatchRequestItemFromJSON)),
        'keyFigures': json['keyFigures'] == null ? undefined : ((json['keyFigures'] as Array<any>).map(SimulationKeyFigureRequestItemFromJSON)),
    };
}

export function RecordSimulationMismatchesRequestBodyToJSON(json: any): RecordSimulationMismatchesRequestBody {
    return RecordSimulationMismatchesRequestBodyToJSONTyped(json, false);
}

export function RecordSimulationMismatchesRequestBodyToJSONTyped(value?: RecordSimulationMismatchesRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefix': value['prefix'],
        'mismatches': ((value['mismatches'] as Array<any>).map(SimulationMismatchRequestItemToJSON)),
        'keyFigures': value['keyFigures'] == null ? undefined : ((value['keyFigures'] as Array<any>).map(SimulationKeyFigureRequestItemToJSON)),
    };
}

